import { render, staticRenderFns } from "./SidebarAddGroup.vue?vue&type=template&id=5004ceab&"
import script from "./SidebarAddGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarAddGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports